require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-sophie-baldwin.json") })
        }
      }, "path---people-sophie-baldwin");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-sophie-baldwin!./.cache/json/people-sophie-baldwin.json
// module id = 1475
// module chunks = 231608221292675